var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgC = function SvgC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h58v32H0zm58 0 18 15.5L58 32V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.452 22.18c1.872 0 3.276-.504 4.5-1.368l-.684-2.142c-.9.648-2.178 1.224-3.636 1.224-2.592 0-4.266-1.854-4.266-4.302 0-2.502 1.728-4.266 4.266-4.266 1.278 0 2.394.486 3.33 1.152l.792-2.196c-1.08-.72-2.502-1.242-4.212-1.242-3.87 0-6.714 2.664-6.714 6.588 0 3.87 2.736 6.552 6.624 6.552Z",
    fill: "#fff"
  })));
};
export default SvgC;